module.exports = __webpack_public_path__ + "img/be657dc.png";